module.exports = __webpack_public_path__ + "static/media/jeep-lwb-side-1.54611593.webp";